import { Injectable, OnDestroy } from '@angular/core';

// WPG 031418 use this as a singleton on root level -- this is temp solution to fix non-reliable angular2-jwt tokengetter()
@Injectable()
export class XRMjwtStoreService {
  private jwt_token = '';

  public getToken() {
    return this.jwt_token;
  }

  public setToken(t) {
    this.jwt_token = t;
  }
}